import React, { useState, useEffect } from 'react';

const ROLES = ['read', 'write', 'admin'];

const DevUserSwitcher = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) {
      setCurrentUser(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem('initialUser');
    if (stored) {
      const initialUser = JSON.parse(stored)

      if(initialUser && initialUser.role === 'admin' && initialUser.admin){
        setVisible(true)
      }else{
        setVisible(false)
      }
    }
  }, []);

  const handleRoleChange = (e) => {
    const role = e.target.value;
    const updated = {
      ...currentUser,
      role,
      admin: currentUser?.admin || false,
    };
    localStorage.setItem('user', JSON.stringify(updated));
    window.location.reload();
  };

  const toggleAdminDSAS = () => {
    const updated = {
      ...currentUser,
      role: 'admin',
      admin: !currentUser?.admin,
    };
    localStorage.setItem('user', JSON.stringify(updated));
    window.location.reload();
  };

  if (!currentUser || !visible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 10,
      right: 200,
      background: '#fff',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '6px',
      zIndex: 1000,
      fontSize: '14px',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
    }}>
      {/* Bouton de fermeture */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>👤 Simulateur de rôle</strong>
        <button
          onClick={() => setVisible(false)}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '16px',
            cursor: 'pointer',
            marginLeft: '10px'
          }}
          aria-label="Fermer"
        >
          ❌
        </button>
      </div>

      <label>
        Rôle :
        <select value={currentUser.role} onChange={handleRoleChange}>
          {ROLES.map(role => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
      </label>

      {currentUser.role === 'admin' && (
        <div style={{ marginTop: 5 }}>
          <label>
            <input
              type="checkbox"
              checked={!!currentUser.admin}
              onChange={toggleAdminDSAS}
            /> Admin DSAS
          </label>
        </div>
      )}
    </div>
  );
};

export default DevUserSwitcher;